import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Avatar,
  IconButton,
  Box,
  Button,
  Collapse,
  Tooltip
} from "@mui/material";
import logo from "../../src/assets/Images/FinalB.png";
import leopharma from '../../src/assets/Images/leopharma.png';
import DatasetOutlinedIcon from "@mui/icons-material/DatasetOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { LuPanelLeftClose } from "react-icons/lu";
import Logout from "@mui/icons-material/Logout";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import { Link, useLocation, useNavigate } from "react-router-dom";
import Profile from "./Profile";
const drawerWidth = 260;

const Sidebar = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const location = useLocation();
  const [NavTitle, setNavTitle] = useState(null);
  const [openMenus, setOpenMenus] = useState({ "Managed Tracker": true });
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleMenuToggle = (header) => {
    setOpenMenus((prev) => ({
      ...prev,
      [header]: !prev[header],
    }));
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname.match(/^\/\d+/);
    }
    return location.pathname.startsWith(path);
  };
  

  const handleLogout=()=>{
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      navigate('/login')
  }
  
  const navItems = [
    {
      header: "Managed Tracker",
      icon: <DashboardOutlinedIcon />,
      subItems: [
        {
          header: "Today's Records",
          link: "/",
          icon: <AccountTreeOutlinedIcon fontSize="small" />,
        },
        {
          header: "Add Data File Status",
          link: "/datafiles",
          icon: <DatasetOutlinedIcon fontSize="small" />,
        },
        {
          header: "Add Curation Status",
          link: "/curation",
          icon: <FilterAltIcon fontSize="small" />,
        },
        {
          header: "View History",
          link: "/history",
          icon: <ManageHistoryIcon fontSize="small" />,
        },
      ],
    },
     {
      header: "BI Data Audit",
      link: "/bi_data_audit",
      icon: <PlayCircleOutlineIcon />,
    },
     {
      header: "Rx Trends & Movements",
      link: "/rx_trend",
      icon: <MedicationOutlinedIcon />,
    },
  ];
  useEffect(() => {
    const findHeader = (items) => {
      for (const item of items) {
        if (item.link === location.pathname) return item.header;
        if (item.subItems) {
          const subHeader = findHeader(item.subItems);
          if (subHeader) return subHeader;
        }
      }
      return null;
    };
    const header = findHeader(navItems);
    if (header) {
      setNavTitle(header);
    }
  }, [location.pathname]);

  return (
    <div style={{backgroundColor:'#f9f9fc'}}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerOpen ? drawerWidth : 60,
          flexShrink: 0,
         

          transition: "width 0.3s",
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidth : 60,
            backgroundColor: "#FFF",
            boxSizing: "border-box",
            transition: "all 0.2s",
            overflow: "hidden",
            borderRight:"none"
          },
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            
            // padding: "8px",
          }}
        >
          <List
            sx={{ color: "#f3f3f3", display: drawerOpen ? "block" : "none" , borderRight:"none"}}
          >
            <img src={leopharma} height={50} width={200} />
          </List>
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              color: "#0576FC",
              transform: drawerOpen ? "rotate(0deg)" : "rotate(180deg)",
              margin:"10px",
              transition: "transform 0.3s",
              // background:"#c4b8f3",
              // height:"34px",
              // width:"34px"
              
            }}
          >
            <KeyboardDoubleArrowLeftIcon />
          </IconButton>
        </div>
        <Divider />

        <List sx={{ px: 1.5, py: 2 }}>
          {navItems.map((item, index) => {
            const hasSubItems = item.subItems && item.subItems.length > 0;
            const isMenuOpen = openMenus[item.header];
            const isAnySubActive = hasSubItems && item.subItems.some(sub => isActive(sub.link));
            const active = isActive(item.link) || isAnySubActive;

            return (
              <Box key={index} sx={{ mb: index === 0 ? 1.5 : 0.5 }}>
                <Tooltip 
                  title={!drawerOpen ? item.header : ""} 
                  placement="right"
                  arrow
                  disableHoverListener={drawerOpen}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      px: drawerOpen ? 1.5 : 1.2,
                      py: 1.2,
                      mx: drawerOpen ? 0 : 0.5,
                      borderRadius: "10px",
                      cursor: "pointer",
                      // Pill-shaped highlight for main items
                      backgroundColor: active && !hasSubItems ? "#F4F9FF" : "transparent",
                      color: active ? "#0576FC" : "#475569",
                      transition: "all 0.2s ease",
                      justifyContent: drawerOpen ? 'flex-start' : 'center',
                      "&:hover": {
                        backgroundColor: "#F8FAFC", // Subtle hover
                        color: "#0576FC",
                      },
                    }}
                    onClick={() => {
                      if (hasSubItems) {
                        if (!drawerOpen) {
                          setDrawerOpen(true);
                          setOpenMenus((prev) => ({ ...prev, [item.header]: true }));
                        } else {
                          handleMenuToggle(item.header);
                        }
                      } else {
                        setNavTitle(item.header);
                        navigate(item.link);
                      }
                    }}
                  >
                    <ListItemIcon
                      sx={{ 
                        color: (active && !hasSubItems) || (active && !drawerOpen) ? "#0576FC" : "#334155", 
                        minWidth: drawerOpen ? 40 : 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        "& .MuiSvgIcon-root": { fontSize: "22px" }
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.header}
                      primaryTypographyProps={{
                        sx: { 
                          fontSize: "14.5px", 
                          fontWeight: active ? 600 : 500,
                          color: active && !hasSubItems ? "#0576FC" : "#334155",
                          fontFamily: "'Inter', sans-serif"
                        },
                        display: drawerOpen ? "block" : "none",
                      }}
                    />
                    {hasSubItems && drawerOpen && (
                      isMenuOpen ? <ExpandLess sx={{ fontSize: '18px', opacity: 0.4 }} /> : <ExpandMore sx={{ fontSize: '18px', opacity: 0.4 }} />
                    )}
                  </Box>
                </Tooltip>

                {hasSubItems && (
                  <Collapse in={isMenuOpen && drawerOpen} timeout="auto" unmountOnExit>
                    <Box sx={{ 
                      ml: 3.8, 
                      mt: 0.5,
                      mb: 1,
                      pl: 1.5,
                      borderLeft: '2px solid #F1F5F9'
                    }}>
                      <List component="div" disablePadding>
                        {item.subItems.map((subItem, subIndex) => {
                          const subActive = isActive(subItem.link);
                          const isLast = subIndex === item.subItems.length - 1;
                          return (
                            <Tooltip 
                              key={subIndex}
                              title={!drawerOpen ? subItem.header : ""} 
                              placement="right"
                              arrow
                              disableHoverListener={drawerOpen}
                            >
                              <Box
                                sx={{
                                  position: "relative",
                                }}
                              >
                                <Box
                                  sx={{
                                    borderRadius: "8px",
                                    mb: 0.5,
                                    ml: 0.5,
                                    "&:hover": {
                                      backgroundColor: "#F8FAFC",
                                    },
                                  }}
                                  onClick={() => setNavTitle(subItem.header)}
                                >
                                  <ListItem
                                    button
                                    component={Link}
                                    to={subItem.link}
                                    sx={{
                                      color: subActive ? "#0576FC" : "#64748B",
                                      borderRadius: "8px",
                                      py: 0.6,
                                      px: 1.2,
                                      backgroundColor: subActive ? "#F4F9FF" : "transparent",
                                      "&:hover": {
                                        backgroundColor: "#F8FAFC",
                                      },
                                    }}
                                  >
                                    <ListItemIcon
                                      sx={{ 
                                        color: subActive ? "#0576FC" : "#64748B",
                                        minWidth: 32,
                                        "& .MuiSvgIcon-root": { fontSize: "20px" }
                                      }}
                                    >
                                      {subItem.icon}
                                    </ListItemIcon>
                                  <ListItemText
                                    primary={subItem.header}
                                    primaryTypographyProps={{
                                      sx: { 
                                        fontSize: "13px", 
                                        fontWeight: subActive ? 600 : 400,
                                        fontFamily: "'Inter', sans-serif"
                                      },
                                      display: drawerOpen ? "block" : "none",
                                    }}
                                  />
                                </ListItem>
                              </Box>
                            </Box>
                          </Tooltip>
                        );
                        })}
                      </List>
                    </Box>
                  </Collapse>
                )}
              </Box>
            );
          })}
          <Tooltip 
            title={!drawerOpen ? "Logout" : ""} 
            placement="right"
            arrow
            disableHoverListener={drawerOpen}
          >
            <Button
              onClick={handleLogout}
              sx={{
                position: "fixed",
                bottom: "2rem",
                left: drawerOpen ? "10px" : "5px",
                overflow: "hidden",
                color: "#333",
                margin: "10px",
                paddingY: "10px",
                paddingRight: drawerOpen ? "8rem" : "0",
                minWidth: drawerOpen ? "auto" : "40px",
                "&:hover": {
                  backgroundColor: "#F0F7FF",
                  borderRadius: "12px",
                },
              }}
            >
              <Box style={{ display: 'flex', alignItems: 'center' }}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Logout fontSize="small" />
                </ListItemIcon>
                {drawerOpen && (
                  <ListItemText
                    primary={"Logout"}
                    primaryTypographyProps={{
                      sx: { 
                        fontSize: "14px", 
                        fontWeight: 500,
                        color: "#000",
                        marginBottom: "-4px" 
                      },
                    }}
                  />
                )}
              </Box>
            </Button>
          </Tooltip>
        </List>
    
      </Drawer>
      <div
        style={{
          backgroundColor: "#f9f9fc",
          // borderBottom: "2px solid #EAEAEA",
          height: "60px",
          display: "flex",
          alignItems: "center",
          marginLeft: drawerOpen ? drawerWidth : 60,
          transition: "margin-left 0.3s",
          position:"fixed",
          top:"0",
          zIndex:"10",
          // backgroundColor:"#333",
          width: drawerOpen ? "calc(100% - 260px)" : "calc(100% - 60px)",
           display:"flex",
          justifyContent:"space-between"
        }}
      >
        <Typography
          // variant="h5"
          sx={{
            marginLeft:"3.5%",
            fontWeight:"400",
            fontSize:"1rem"
          }}
        >
          {" "}
         {location.pathname === '/1' ? "Today's Records" : NavTitle}
        </Typography>
        <div style={{
          marginRight:"3.3%"
          }}><Profile/></div>
      </div>
      <main
        style={{
          marginLeft: drawerOpen ? drawerWidth : 60,
          transition: "margin-left 0.3s",
          marginTop:"3.7rem",
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default Sidebar;